<template>
  <div class="result">
    <p><strong>Resultate für Gemeinde {{estimate.gemeindeName}}</strong></p>
    <p>
      {{estimate.resultText}}
    </p>
    <div class="alert alert-danger alert-dotted" role="alert">
      <h2><strong>{{estimate.gesuchsartBezeichnung}}</strong></h2>
      <table class="calc-table">
        <tr v-if="estimate.gefoerdertDurchKanton">
          <th scope="row">Förderbeitrag Kanton</th>
          <td><strong>CHF {{estimate.foerderbetragKanton | formatCurrency}}</strong></td>
        </tr>
        <tr v-if="estimate.gefoerdertDurchGemeinde">
          <th scope="row">Förderbeitrag Gemeinde</th>
          <td><strong>CHF {{estimate.foerderbetragGemeinde  | formatCurrency}}</strong></td>
        </tr>
        <tr class="total">
          <th scope="row"><strong>Total</strong></th>
          <td><strong>CHF {{estimate.foerderbetragBund + estimate.foerderbetragGemeinde + estimate.foerderbetragKanton | formatCurrency}}</strong></td>
        </tr>
      </table>
    </div>
    <!-- <p><em><small>* Folgende Gemeinden unterstützen aktuell den Heizungsersatz mit einem Zusatzbeitrag:</small></em></p>
    <p><a href="#"><strong>Tübach</strong></a>, <a href="#"><strong>Gossau</strong></a>, <a href="#"><strong>Buchs (SG)</strong></a>, <a href="#"><strong>Tübach</strong></a></p> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        estimate: state => state.calculator.estimate
      })
    }
  }
</script>

<style lang="scss" scoped>
  .result{
    margin: 1rem 0;
    color: $black-60;

    a{
      color: $black-60
    }
  }
  .el-select{
    display: block;
  }
  .alert-dotted{
    border: 2px dotted $magenta;
    color: $magenta;
    padding: 1rem;

    .calc-table{
      margin-bottom: 1rem;
      width: 100%;

      th{
        font-weight: $font-weight-regular;
      }
      td{
        vertical-align: top;
        text-align: right;
        strong{
          white-space: nowrap;
        }
      }
      .total{
        border-top: 2px solid $magenta;
        border-bottom: 2px solid $magenta;
      }
    }
  }
</style>
